const START_PATH = /^\/protocol\/([^/]+)\/start(?:\/|$)/;
const PARTICIPATION_PATH = /^\/participation\/([^/]+)(?:\/|$)/;
const PARTICIPATION_ID_SEPARATOR = '__';

const decodeSegment = (segment: string | undefined): string | undefined => {
  try {
    return decodeURIComponent(segment ?? '');
  } catch {
    return undefined;
  }
};

// Participation ids are `{uid}__{protocolId}`.
export const protocolIdFromParticipationId = (
  participationId: string | undefined
): string | undefined => {
  if (participationId === undefined) return undefined;
  const separatorIndex = participationId.indexOf(PARTICIPATION_ID_SEPARATOR);
  if (separatorIndex < 0) return undefined;
  const protocolId = participationId.slice(
    separatorIndex + PARTICIPATION_ID_SEPARATOR.length
  );
  return protocolId === '' ? undefined : protocolId;
};

export const protocolIdFromPath = (pathname: string): string | undefined => {
  const start = START_PATH.exec(pathname);
  if (start) return decodeSegment(start[1]);

  const participation = PARTICIPATION_PATH.exec(pathname);
  if (!participation) return undefined;
  return protocolIdFromParticipationId(decodeSegment(participation[1]));
};
